import React, { useState, useRef } from 'react';
import {
  IconContainer,
  InputContainer,
  StyledTextInput,
  StyledTextInputContainer,
  StyledTextLabel,
} from './styled.textInput';
import { ITextInput } from '../../../@types/textInput';
import { Body5 } from './../../typography';
import { ErrorValidation } from './../ErrorValidation';
import { useTranslation } from 'react-i18next';
import { ClosedEye } from '../../icons/ClosedEye';
import { OpenedEye } from '../../icons/OpenedEye';

export function TextInput ({
  onValueChange,
  textValue,
  title,
  placeholder,
  errorMessage,
  isError,
  disabled,
  inputType = 'text',
}: ITextInput) {
  const { t } = useTranslation();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  return (
    <StyledTextInputContainer>
      {title && (
        <StyledTextLabel>
          <Body5 color="eerieBlack">{title}</Body5>
        </StyledTextLabel>
      )}
      <InputContainer>
        <StyledTextInput
          onChange={onChange}
          ref={textareaRef}
          value={textValue}
          placeholder={placeholder}
          disabled={disabled}
          isError={isError}
          type={showPassword ? 'text' : inputType}
          hasIcon={inputType === 'password'}
        />
        {inputType === 'password' && (
          <IconContainer
            disabled={disabled}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <OpenedEye /> : <ClosedEye />}
          </IconContainer>
        )}
      </InputContainer>
      {isError && (
        <ErrorValidation
          message={
            errorMessage ||
            t('COMMON.MY_AUDIT.ASSIGN_FORM.PLEASE_FILL_VALID_DETAILS')
          }
        />
      )}
    </StyledTextInputContainer>
  );
}
